/*
 * File: c:\Users\t.boisseau\Desktop\MOBYBUY\mobybuy_client\src\Content\ClosurePage\ClosurePage.tsx
 * Project: c:\Users\t.boisseau\Desktop\MOBYBUY\mobybuy_client
 * Created Date: Monday July 28th 2025
 * Author: Tommy Boisseau
 * -----
 * Last Modified: Monday July 28th 2025 9:00:53 am
 * Modified By: the developer formerly known as Tommy Boisseau at t.boisseau@autobuy.fr
 * -----
 * Copyright (c) 2025 Autobuy SAS
 * -----
 */

import { useEffect, useState } from 'react';
import Styles from './ClosurePage.module.css';

const TemporaryClosurePage = () => {
  const [imageSrc, setImageSrc] = useState('bg-holidays.png');

  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth <= 750) {
        setImageSrc('bg-holidays-phone.png');
      } else {
        setImageSrc('bg-holidays.png');
      }
    };

    updateImage();
    window.addEventListener('resize', updateImage);
    return () => window.removeEventListener('resize', updateImage);
  }, []);

  return (
    <img className={Styles.picture} src={imageSrc} alt="bg-holidays" />
  )
};

export default TemporaryClosurePage;
